
import { FETCH_INVEST_SUCCESS, FETCH_INVEST_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  investData: [],
  error: null,
  redirectToLoginPage: false,
};

const investReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVEST_SUCCESS:
      return {
        ...state,
        investData: action.payload.investData,
        error: null,
      };
    case FETCH_INVEST_FAILURE:
      return {
        ...state,
        investData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default investReducer;
